export default "__VITE_ASSET__64f38038__"